module.exports = (__webpack_require__(6))(11);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/object-assign/index.js from dll-reference vendor_aa0bb54e7e791c5951ff
// module id = 167
// module chunks = 0 1 2